/* Bestellstatus im Shop (Roadmap 3.41 Paket B, Konzept docs/konzept_bestellstatus_shop.md in mhsys, Abschnitt 3).
 *
 * Geladen aus layout/theme.liquid nur auf /pages/bestellstatus (template.suffix "bestellstatus").
 * Endpunkt: /apps/kunde?bereich=status&teil=... (App-Proxy "MHSys Kundeninhalte", mhsys extern/kundeninhalte/status),
 * nur POST mit JSON:
 *   anmelden  {bestellnr, email, website, _stempel} -> {ok, token} | {ok:false, fehler, meldung?}
 *   code      {code}                              -> {ok, token}   (Einmal-Code aus service.mhsys.de, Paket C)
 *   ansicht   {token}                             -> die Ansicht    (bestellstatus_ansicht(), Konzept 3.2)
 *
 * Regeln (Konzept 1 und 3.5):
 * - Der Token steht NUR in sessionStorage und im Rumpf der POSTs, nie in einer Adresse. Der Einmal-Code kommt als
 *   #c=... - der Kopf der Seite (layout/theme.liquid) nimmt ihn vor jedem Pixel aus der Adresse und legt ihn in
 *   window.mhsysBsCode; hier wird er nur noch eingeloest.
 * - Jeder Wert aus der Antwort geht mit textContent in die Seite, nie mit innerHTML (der Kundenhinweis ist Freitext
 *   aus order.php). Links und Bilder nur mit https:.
 * - Die Texte zum Stand der Bestellung kommen fertig aus dem Backend; hier steht nur, was die Seite selbst sagt.
 */
(function () {
  "use strict";
  var wurzel = document.querySelector("[data-mhsys-bestellstatus]");
  if (!wurzel || wurzel.getAttribute("data-bs-bereit")) return;
  wurzel.setAttribute("data-bs-bereit", "1");

  var BASIS = "/apps/kunde?bereich=status&teil=";
  var SCHLUESSEL = "mhsysBestellstatus";
  /* Zeitstempel statt _dauer (Roadmap 7.59): window.mhsysStempel aus mhsys-kopf.js haengt _stempel an, warm geholt beim Oeffnen */
  function stempeln(r) { return window.mhsysStempel ? window.mhsysStempel.mit(r) : Promise.resolve(r); }
  if (window.mhsysStempel) window.mhsysStempel.vor();
  var titel = wurzel.querySelector("[data-bs-titel]");
  var titelStart = titel.textContent;
  var unter = wurzel.querySelector("[data-bs-unter]");
  var inhalt = wurzel.querySelector("[data-bs-inhalt]");
  var formular = wurzel.querySelector("[data-bs-formular]");
  var meldung = wurzel.querySelector("[data-bs-meldung]");
  var suchen = wurzel.querySelector("[data-bs-suchen]");
  var hilfe = wurzel.querySelector("[data-bs-hilfe]");
  // Roadmap 3.42: im Shop angemeldet (nur ja/nein aus dem Liquid) - dann zuerst die eigene Liste statt des Formulars
  var kunde = wurzel.hasAttribute("data-bs-kunde");
  var andereKnopf = wurzel.querySelector("[data-bs-andere]");

  var MELDUNGEN = {
    nicht_gefunden: "Bestellnummer und E-Mail-Adresse passen nicht zusammen. Bitte prüf deine Angaben – die Bestellnummer steht in deiner Bestellbestätigung, die E-Mail-Adresse ist die, mit der du bestellt hast.",
    gesperrt: "Zu viele Versuche. Bitte probier es in einer Stunde noch einmal.",
    grenze: "Gerade kommen zu viele Anfragen. Bitte probier es in ein paar Minuten noch einmal.",
    archiviert: "Diese Bestellung ist archiviert. Hast du eine Frage dazu? Schreib uns einfach.",
    leer: "Bitte gib deine Bestellnummer und deine E-Mail-Adresse ein.",
    abgelaufen: "Bitte melde dich noch einmal mit Bestellnummer und E-Mail-Adresse an.",
  };

  /* ---- Hilfen ---- */
  function lesen() { try { return sessionStorage.getItem(SCHLUESSEL) || ""; } catch (e) { return ""; } }
  function merken(t) { try { t ? sessionStorage.setItem(SCHLUESSEL, t) : sessionStorage.removeItem(SCHLUESSEL); } catch (e) {} }
  function text(v) { return v === null || v === undefined ? "" : String(v); }
  function sicher(url) { url = text(url); return /^https:\/\/[^\s]+$/i.test(url) ? url : ""; }
  function el(tag, klasse, inhaltText) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (inhaltText !== undefined && inhaltText !== null && inhaltText !== "") e.textContent = String(inhaltText);
    return e;
  }
  // mhsys hat nicht lesbar geantwortet (HTML-Fehlerseite des Proxys oder Hosters, 5xx) - das ist eine Stoerung, keine
  // falsche Eingabe: dann der Fehler-Zustand, nie "passen nicht zusammen" (Roadmap 7.44)
  function stoerung(a) { return !a || a.fehler === "antwort" || a.status_http >= 500; }
  function auswerten(r) {
    return r.json().catch(function () { return { ok: false, fehler: "antwort" }; }).then(function (j) {
      j = j && typeof j === "object" ? j : { ok: false, fehler: "antwort" };
      j.status_http = r.status;
      return j;
    });
  }
  // Mit Zeitlimit (layout/theme.liquid, Roadmap 7.44): antwortet mhsys nicht, kommt der Fehler-Zustand statt ewigem Laden
  function holen(url, init) { return window.mhsysNetz ? window.mhsysNetz.holen(url, init) : fetch(url, init); }
  function senden(teil, daten) {
    return holen(BASIS + teil, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(daten || {}),
      credentials: "same-origin",
      cache: "no-store",
    }).then(auswerten);
  }

  /* ---- Zustaende ---- */
  function zustand(name) {
    var alle = wurzel.querySelectorAll("[data-bs-zustand]");
    for (var i = 0; i < alle.length; i++) alle[i].hidden = alle[i].getAttribute("data-bs-zustand") !== name;
    wurzel.setAttribute("data-bs-aktiv", name);
    if (name !== "ansicht") {
      titel.textContent = titelStart;
      unter.hidden = true;
    }
  }
  function anmelden(hinweis) {
    merken("");
    zustand("anmelden");
    zeigeMeldung(hinweis || "");
  }
  function zeigeMeldung(t) {
    meldung.textContent = t;
    meldung.hidden = !t;
  }

  /* ---- Ablauf ---- */
  function laden(token) {
    zustand("laden");
    return senden("ansicht", { token: token }).then(function (a) {
      if (a && a.ok) { zeichnen(a); return; }
      // Token unbekannt oder abgelaufen: sauber zur Anmeldung, der alte Token ist wertlos
      // grenze (Bremse): ebenfalls zur Anmeldung, mit dem Satz aus dem Backend - kein Fehlerzustand fuer eine Wartezeit
      if (a && (a.fehler === "token" || a.fehler === "nicht_gefunden" || a.fehler === "archiviert" || a.fehler === "grenze")) {
        anmelden(text(a.meldung) || MELDUNGEN[a.fehler === "token" ? "abgelaufen" : a.fehler]);
        return;
      }
      zustand("fehler");
    }).catch(function () { zustand("fehler"); });
  }

  function einloesen(code) {
    zustand("laden");
    return senden("code", { code: code }).then(function (a) {
      if (a && a.ok && a.token) { merken(a.token); return laden(a.token); }
      if (stoerung(a)) { zustand("fehler"); return; }
      // Code verbraucht oder abgelaufen (5 Minuten): anmelden, nicht Fehler - der Kunde kann weiter
      anmelden(text(a && a.meldung) || MELDUNGEN.abgelaufen);
    }).catch(function () { zustand("fehler"); });
  }

  formular.addEventListener("submit", function (ev) {
    ev.preventDefault();
    var nr = text(formular.elements.bestellnr.value).trim();
    var mail = text(formular.elements.email.value).trim();
    if (!nr || !mail) { zeigeMeldung(MELDUNGEN.leer); return; }
    zeigeMeldung("");
    suchen.disabled = true;
    stempeln({
      bestellnr: nr,
      email: mail,
      website: text(formular.elements.website.value),
    }).then(function (r) { return senden("anmelden", r); }).then(function (a) {
      suchen.disabled = false;
      if (a && a.ok && a.token) { merken(a.token); formular.reset(); laden(a.token); return; }
      if (stoerung(a)) { zustand("fehler"); return; }
      var f = text(a && a.fehler);
      zeigeMeldung(text(a && a.meldung) || MELDUNGEN[f] || MELDUNGEN.nicht_gefunden);
    }).catch(function () {
      suchen.disabled = false;
      zustand("fehler");
    });
  });

  andereKnopf.addEventListener("click", function () {
    wurzel.scrollIntoView({ block: "start" });
    // Angemeldet: zurueck zu "Meine Bestellungen" (Shopify), ohne die Seite zur Liste aus mhsys; sonst das Formular
    if (kunde) {
      auswahlMerken(null);
      if (bestellungenSeite) { window.location.href = bestellungenSeite; return; }
      merken(""); meineLaden(""); return;
    }
    anmelden("");
    formular.elements.bestellnr.focus({ preventScroll: true });
  });
  // "Zurueck zur Bestelluebersicht" ganz oben: die gemerkte Wahl gilt dann nicht mehr
  var zurueckLink = wurzel.querySelector("[data-bs-zurueck]");
  if (zurueckLink) zurueckLink.addEventListener("click", function () { auswahlMerken(null); });
  // Angemeldet mit dem Link oben kein zweiter Weg zurueck unten (Inhaber 26.09.2026); Gaeste behalten "Andere Bestellung pruefen"
  if (kunde && zurueckLink) andereKnopf.parentNode.hidden = true;
  wurzel.querySelector("[data-bs-zum-formular]").addEventListener("click", function () {
    anmelden("");
    formular.elements.bestellnr.focus({ preventScroll: true });
  });

  /* ---- Meine Bestellungen (Roadmap 3.42 C, Proxy teil=meine/oeffnen von Enna) ----
     Die Liste traegt keinen Token; erst teil=oeffnen liefert ihn, und nur fuer eine Bestellung dieses Kunden. Danach
     laeuft alles wie nach der Anmeldung. Faellt die Liste aus (401, Fehler), bleibt das Formular - nie eine Sackgasse. */
  var listeMeldung = wurzel.querySelector("[data-bs-liste-meldung]");
  function meineLaden(hinweis) {
    zustand("laden");
    return senden("meine", {}).then(function (a) {
      var liste = a && a.ok && Array.isArray(a.bestellungen) ? a.bestellungen : null;
      if (!liste) { anmelden(""); return; }
      if (!liste.length) { anmelden("Zu deinem Kundenkonto finden wir keine Bestellung aus den letzten Monaten. Hier kannst du sie mit Bestellnummer und E-Mail-Adresse suchen."); return; }
      listeZeichnen(liste);
      listeMeldung.textContent = hinweis || "";
      listeMeldung.hidden = !hinweis;
      zustand("liste");
    }).catch(function () { anmelden(""); });
  }
  function listeZeichnen(liste) {
    var ul = wurzel.querySelector("[data-bs-liste]");
    ul.textContent = "";
    liste.forEach(function (b) {
      var li = el("li");
      var knopf = el("button", "mhsys-bs__eintrag");
      knopf.type = "button";
      var kopf = el("span", "mhsys-bs__eintrag-kopf");
      kopf.appendChild(el("strong", "", text(b.nummer)));
      if (b.datum) kopf.appendChild(el("span", "mhsys-bs__eintrag-datum", "vom " + text(b.datum)));
      knopf.appendChild(kopf);
      var art = b.fall === "adresse" || b.fall === "wunschname" ? "warnung" : b.fall === "storno" ? "leise" : (parseInt(b.schritt, 10) || 0) >= 4 ? "fertig" : "arbeit";
      var zeile = el("span", "mhsys-bs__eintrag-zeile");
      zeile.appendChild(el("span", "mhsys-bs__eintrag-stand mhsys-bs__eintrag-stand--" + art, text(b.stand)));
      var anzahl = parseInt(b.artikel, 10) || 0;
      if (anzahl > 0) zeile.appendChild(el("span", "mhsys-bs__eintrag-artikel", anzahl + " Artikel"));
      knopf.appendChild(zeile);
      knopf.addEventListener("click", function () { oeffnen(text(b.nummer)); });
      li.appendChild(knopf);
      ul.appendChild(li);
    });
  }
  function oeffnen(nummer) {
    zustand("laden");
    senden("oeffnen", { bestellnr: nummer }).then(function (a) {
      if (a && a.ok && a.token) { merken(a.token); laden(a.token); return; }
      if (a && a.fehler === "anmeldung") { anmelden(""); return; }
      meineLaden(text(a && a.meldung) || "Diese Bestellung können wir gerade nicht öffnen.");
    }).catch(function () { zustand("fehler"); });
  }

  wurzel.querySelector("[data-bs-nochmal]").addEventListener("click", start);

  /* ---- Hilfe (Wunsch des Inhabers 23.09.2026) ----
     Normalfall: das Kontaktformular als Overlay (window.mhsysPopupOeffnen aus assets/mhsys-popup.js, wie "Fragen?"
     in der Handyleiste), im Kommentarfeld schon "Bestellung #…". Kein Token ins Formular - die Mail geht ins
     Ticketsystem, die Bestellnummer genuegt dort. Die Ruecksendung (ab Schritt 4) und die Knoepfe im Hinweis-Kasten
     (Lieferadresse, Wunschtext - hinweisZeichnen()) gehen per POST mit Token auf service.mhsys.de (Konzept 3.4). */
  var hilfeKnopf = hilfe.querySelector("[data-bs-hilfe-knopf]");
  var hilfeText = hilfe.querySelector("[data-bs-hilfe-text]");
  var hilfeStart = { text: hilfeText.textContent, knopf: hilfeKnopf.textContent };
  var retoure = hilfe.querySelector("[data-bs-retoure]");
  var service = hilfe.querySelector("[data-bs-service]");
  var hilfeLage = { nummer: "", name: "" };

  // Der Token geht erst beim Abschicken ins Formular und gleich danach wieder heraus
  // ziel (Vertrag mit Paket C): adresse | wunschname | retoure - der Eingang auf service.mhsys.de fuehrt direkt dorthin
  function zurServiceseite(ziel) {
    var t = lesen();
    if (!t) { anmelden(MELDUNGEN.abgelaufen); return; }
    service.querySelector("[data-bs-service-ziel]").value = ziel;
    var feld = service.querySelector("[data-bs-service-token]");
    feld.value = t;
    service.submit();
    setTimeout(function () { feld.value = ""; }, 0);
  }

  function kontaktOeffnen() {
    var url = "/pages/kontaktformular";
    if (typeof window.mhsysPopupOeffnen !== "function") { window.location.href = url; return; }
    window.mhsysPopupOeffnen(url, "Kontakt", { voll: true, verlauf: true, ausloeser: hilfeKnopf });
    if (!hilfeLage.nummer) return;
    // Das Overlay laedt die Seite nach - auf das Kommentarfeld warten, nur ein leeres vorbelegen
    var versuche = 0;
    var uhr = setInterval(function () {
      var feld = document.querySelector(".mhsys-popup #ContactForm textarea");
      if (feld || ++versuche > 40) clearInterval(uhr);
      if (feld && !feld.value.trim()) feld.value = "Bestellung " + hilfeLage.nummer + "\n\n";
    }, 150);
  }

  hilfeKnopf.addEventListener("click", kontaktOeffnen);
  // Roadmap 3.48 R-T: mit der Shop-Seite /pages/retoure dorthin - sie nimmt denselben Token aus sessionStorage
  hilfe.querySelector("[data-bs-retoure-knopf]").addEventListener("click", function () {
    var seite = wurzel.getAttribute("data-bs-retoure-seite") || "";
    // mhsysRtDirekt: die Retoure-Seite oeffnet dann DIESE Bestellung statt erst die Auswahl (assets/mhsys-retoure.js)
    if (seite && lesen()) {
      try { sessionStorage.setItem("mhsysRtDirekt", String(Date.now())); } catch (e) {}
      window.location.href = seite;
      return;
    }
    // Angemeldet ohne Token (mhsys kennt die Bestellung noch nicht): die Retoure-Seite zeigt die Auswahl
    if (seite && kunde) { window.location.href = seite; return; }
    zurServiceseite("retoure");
  });

  /* ---- Ansicht zeichnen ---- */
  function zeichnen(a) {
    inhalt.textContent = "";
    var nummer = text(a.nummer);
    titel.textContent = nummer ? "Bestellung " + nummer : titelStart;
    unter.textContent = a.datum ? "vom " + text(a.datum) : "";
    unter.hidden = !a.datum;

    var aktiv = parseInt(a.schritt, 10) || 0;
    lageZeichnen(a, inhalt);
    if (Array.isArray(a.artikel) && a.artikel.length) inhalt.appendChild(artikelZeichnen(a));

    var zeilen = Array.isArray(a.adresse) ? a.adresse.filter(function (z) { return text(z).trim(); }) : [];
    if (zeilen.length) {
      var ad = el("section", "mhsys-bs__karte");
      ad.appendChild(el("h2", "mhsys-bs__karte-titel", "Lieferadresse"));
      var adr = el("address", "mhsys-bs__adresse");
      zeilen.forEach(function (z, i) { adr.appendChild(el(i === 0 ? "strong" : "span", "", text(z))); });
      ad.appendChild(adr);
      inhalt.appendChild(ad);
    }

    var h = a.hilfe || {};
    hilfeSetzen(nummer, Array.isArray(a.adresse) && a.adresse.length ? text(a.adresse[0]) : "", aktiv >= 4 && a.fall !== "storno", h.zeigen !== false);
    zustand("ansicht");
    adresseGewuenscht(nummer);
  }

  /* Stand aus mhsys: Weg, Hinweis, Push, Nachricht, haengendes Paket, Pakete - in der mhsys-Ansicht oben, in der
     Shopify-Ansicht ueber den Shopify-Daten (Platz data-bs-lage) */
  function lageZeichnen(a, ziel) {
    var schritte = Array.isArray(a.schritte) ? a.schritte : [];
    var aktiv = parseInt(a.schritt, 10) || 0;
    if (aktiv > 0 && schritte.length) ziel.appendChild(wegZeichnen(schritte, aktiv));

    // Bild mit Leni oder Gustl zum Stand (Inhaber 06.10.2026): am Handy über dem Satz, am Rechner links daneben
    var bild = bildZeichnen(a, aktiv);
    var hinweis = a.hinweis && (a.hinweis.text || a.hinweis.titel) ? hinweisZeichnen(a.hinweis, a) : null;
    // Lieferdatum, wie beim Kauf zugesagt (Roadmap 1.131, mhsys versandregeln_bestellstatus()): im Satz zur Lage
    var lf = a.lieferung || null;
    if (lf) {
      if (!hinweis) hinweis = hinweisZeichnen({ art: "info", titel: "", text: "" }, null);
      if (lf.datum) {
        var lfZeile = el("p", "mhsys-bs__lieferung", text(lf.text) + " ");
        lfZeile.appendChild(el("strong", "", text(lf.datum)));
        hinweis.appendChild(lfZeile);
      } else {
        // Versandtag vorbei, noch nicht verschickt: ein ruhiger Satz statt eines Datums, das nicht mehr stimmt
        var lfSpaet = el("p", "mhsys-bs__lieferung");
        lfSpaet.appendChild(el("strong", "", text(lf.titel)));
        lfSpaet.appendChild(document.createTextNode(" " + text(lf.text)));
        hinweis.appendChild(lfSpaet);
      }
      if (text(lf.satz)) hinweis.appendChild(el("p", "mhsys-bs__lieferung-satz", text(lf.satz)));
    }
    if (bild) {
      var szene = el("div", "mhsys-bs__szene");
      szene.appendChild(bild);
      if (hinweis) szene.appendChild(hinweis);
      ziel.appendChild(szene);
    } else if (hinweis) ziel.appendChild(hinweis);

    // Push-Hinweis direkt unter dem Stand (Weg und Satz zur Lage), Konzept 3.5 und 4.1
    var pushPlatz = el("div", "mhsys-bs__push-platz");
    ziel.appendChild(pushPlatz);
    pushZeichnen(pushPlatz, a);

    if (text(a.nachricht).trim()) {
      var n = el("section", "mhsys-bs__karte");
      n.appendChild(el("h2", "mhsys-bs__karte-titel", "Eine Nachricht von uns"));
      n.appendChild(el("p", "mhsys-bs__nachricht", text(a.nachricht)));
      ziel.appendChild(n);
    }

    // Paket haengt (DHL seit ueber 7 Tagen ohne Neuigkeit): Warnung ueber den Paketen, Nachfragen ueber das Kontakt-Overlay
    if (a.paket_hinweis && (a.paket_hinweis.text || a.paket_hinweis.titel)) {
      var ph = hinweisZeichnen(a.paket_hinweis, null);
      var phKnoepfe = el("div", "mhsys-bs__knoepfe mhsys-bs__hinweis-knoepfe");
      var phKnopf = el("button", "mhsys-knopf", "Nachfragen");
      phKnopf.type = "button";
      phKnopf.addEventListener("click", kontaktOeffnen);
      phKnoepfe.appendChild(phKnopf);
      ph.appendChild(phKnoepfe);
      ziel.appendChild(ph);
    }
    if (Array.isArray(a.pakete) && a.pakete.length) ziel.appendChild(paketeZeichnen(a.pakete));
    // Einladung zu „Meine Anlässe“ (Roadmap 3.47 E, Enna/Fiete 29.09.2026): mhsys setzt sie nur ab Schritt 5 (alles zugestellt),
    // nie bei Storno, Archiv, Adresse oder Wunschtext - unter den Paketen, damit sie nichts Wichtigeres verdrängt
    if (a.einladung && (a.einladung.text || a.einladung.titel)) ziel.appendChild(hinweisZeichnen(a.einladung, null));
  }

  /* Welches Bild zum Stand gehört: erst der Sonderfall, sonst der Schritt (1-5). Archiviert und unbekannte Fälle ohne Bild.
     Die Adressen stehen im Liquid (data-bs-bilder, asset_url), die Bilder macht docs/bestellstatus-bilder.py. */
  var BILD_SCHRITTE = ["bestellt", "arbeit", "verpackt", "unterwegs", "zugestellt"];
  var bilder = {};
  try { bilder = JSON.parse(wurzel.getAttribute("data-bs-bilder") || "{}") || {}; } catch (e) {}
  function bildZeichnen(a, aktiv) {
    var fall = text(a.fall);
    /* Vorbestellung (Bestellung pausiert, seit 14.10.2026): eigener Hinweis aus mhsys, Bild wie der Schritt */
    var name = /^(adresse|wunschname|termin|storno)$/.test(fall) ? fall : (!fall || fall === "vorbestellung") ? BILD_SCHRITTE[aktiv - 1] : "";
    var url = name && typeof bilder[name] === "string" ? bilder[name] : "";
    if (!url) return null;
    var img = document.createElement("img");
    img.className = "mhsys-bs__bild";
    img.src = url;
    img.alt = "";
    img.width = 320;
    img.height = 250;
    img.decoding = "async";
    return img;
  }

  // Hilfe-Karte: Kontaktformular mit der Nummer; "Ruecksendung oder Reklamation" erst ab dem Versand und nicht bei Storno
  function hilfeSetzen(nummer, name, mitRetoure, zeigen) {
    hilfeLage.nummer = nummer;
    hilfeLage.name = name || "";
    andereKnopf.textContent = kunde ? "Zurück zu meinen Bestellungen" : "Andere Bestellung prüfen";
    hilfeText.textContent = hilfeStart.text;
    hilfeKnopf.textContent = hilfeStart.knopf;
    retoure.hidden = !mitRetoure;
    hilfe.hidden = !zeigen;
  }

  function wegZeichnen(schritte, aktiv) {
    var box = el("div", "mhsys-bs__weg");
    var ol = el("ol", "mhsys-bs__schritte");
    schritte.forEach(function (s, i) {
      var nr = i + 1;
      var li = el("li", nr < aktiv ? "ist-fertig" : nr === aktiv ? "ist-aktiv" : "");
      if (nr === aktiv) li.setAttribute("aria-current", "step");
      li.appendChild(el("span", "mhsys-bs__schritt-text", text(s)));
      ol.appendChild(li);
    });
    box.appendChild(ol);
    // Am Handy passen fuenf Beschriftungen nicht nebeneinander: nur die Balken und darunter diese Zeile
    var mobil = el("p", "mhsys-bs__schritt-mobil", "Schritt " + aktiv + " von " + schritte.length + " · ");
    mobil.appendChild(el("strong", "", text(schritte[aktiv - 1])));
    box.appendChild(mobil);
    return box;
  }

  function hinweisZeichnen(h, a) {
    var art = /^(info|warnung|erfolg)$/.test(text(h.art)) ? h.art : "info";
    var box = el("div", "mhsys-bs__hinweis mhsys-bs__hinweis--" + art);
    if (h.titel) box.appendChild(el("strong", "mhsys-bs__hinweis-titel", text(h.titel)));
    if (h.text) box.appendChild(el("span", "", text(h.text)));
    var link = sicher(h.link);
    if (link && h.link_text) {
      var ln = el("a", "mhsys-bs__hinweis-link", text(h.link_text));
      ln.href = link;
      ln.rel = "noopener";
      box.appendChild(ln);
    }
    // Lieferadresse und Wunschtext: der Weg steht direkt im Kasten (Wunsch des Inhabers 23.09.2026), nicht noch einmal
    // in der Hilfe-Karte. POST mit Token auf service.mhsys.de - dort ist der Kunde gleich angemeldet.
    // Roadmap 3.48 A-T: Wunschtext direkt hier, sobald das Backend teil=kontakt dafuer annimmt (a.kontakt)
    if (a && a.fall === "wunschname" && Array.isArray(a.kontakt) && a.kontakt.indexOf("wunschtext") >= 0) {
      box.appendChild(wunschtextFormular());
      return box;
    }
    if (a && (a.fall === "adresse" || a.fall === "wunschname")) {
      var knoepfe = el("div", "mhsys-bs__knoepfe mhsys-bs__hinweis-knoepfe");
      var knopf = el("button", "mhsys-knopf", text(a.hilfe && a.hilfe.knopf) || (a.fall === "adresse" ? "Lieferadresse korrigieren" : "Wunschtext schicken"));
      knopf.type = "button";
      // Adresse: das Formular direkt hier im Kasten (Inhaber 26.09.2026); ohne Vorlage oder Token wie bisher auf die
      // Shop-Seite /pages/adresse bzw. service.mhsys.de
      var adresseSeite = wurzel.getAttribute("data-bs-adresse-seite") || "";
      if (a.fall === "adresse") knopf.setAttribute("data-bs-ad-auf", "");
      knopf.addEventListener("click", function () {
        if (a.fall === "adresse" && adresseFormular(box, knoepfe)) return;
        if (a.fall === "adresse" && adresseSeite && lesen()) { window.location.href = adresseSeite; return; }
        zurServiceseite(a.fall);
      });
      knoepfe.appendChild(knopf);
      box.appendChild(knoepfe);
    }
    return box;
  }

  /* ---- Lieferadresse direkt im Kasten (Inhaber 26.09.2026) ----
     Dieselben Endpunkte wie /pages/adresse (assets/mhsys-adresse.js): adresse&teil=laden {token} und
     adresse&teil=speichern {token, adresse, schluessel} - schluessel gegen doppeltes Speichern, gleich bei gleichen
     Angaben. Werte nur per value/textContent. Liefert false, wenn es hier nicht geht (keine Vorlage, kein Token). */
  var AD_FELDER = ["name", "firma", "strasse", "zusatz", "zusatz2", "plz", "ort"];
  var AD_PFLICHT = { name: "Bitte gib deinen Namen ein.", strasse: "Bitte gib Straße und Hausnummer ein.", plz: "Bitte gib die PLZ ein.", ort: "Bitte gib den Ort ein." };
  function adresseSenden(teil, daten) {
    return holen("/apps/kunde?bereich=adresse&teil=" + teil, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(daten || {}),
      credentials: "same-origin",
      cache: "no-store",
    }).then(auswerten);
  }
  function adresseFormular(box, knoepfe) {
    var vorlage = wurzel.querySelector("template[data-bs-adresse-vorlage]");
    var token = lesen();
    if (!vorlage || !token || box.querySelector("form")) return !!box.querySelector("form");
    var f = vorlage.content.firstElementChild.cloneNode(true);
    var felder = f.querySelector("[data-bs-ad-felder]");
    var laden = f.querySelector("[data-bs-ad-laden]");
    var meldungAd = f.querySelector("[data-bs-ad-meldung]");
    var speichernKnopf = f.querySelector("[data-bs-ad-speichern]");
    var stand = null;
    var laeuft = false;
    knoepfe.hidden = true;
    box.appendChild(f);
    function zeigeFehler(satz) { meldungAd.textContent = satz || ""; meldungAd.hidden = !satz; }
    function feldfehler(fe) {
      Object.keys(AD_PFLICHT).forEach(function (k) {
        var pf = f.querySelector('[data-bs-ad-feldfehler="' + k + '"]');
        var satz = fe && fe[k] ? text(fe[k]) : "";
        if (pf) { pf.textContent = satz; pf.hidden = !satz; }
        satz ? f.elements[k].setAttribute("aria-invalid", "true") : f.elements[k].removeAttribute("aria-invalid");
      });
    }
    function schliessen() { f.remove(); knoepfe.hidden = false; }
    f.querySelector("[data-bs-ad-abbrechen]").addEventListener("click", schliessen);
    adresseSenden("laden", { token: token }).then(function (a) {
      if (!a || !a.ok) {
        if (a && a.fehler === "token") merken("");
        schliessen();
        var m = el("p", "mhsys-formular__meldung mhsys-formular__meldung--fehler", text(a && a.meldung) || "Die Adresse können wir gerade nicht laden. Probier es gleich noch einmal.");
        m.setAttribute("role", "alert");
        box.appendChild(m);
        return;
      }
      var ad = a.adresse || {};
      AD_FELDER.forEach(function (k) { f.elements[k].value = text(ad[k]); });
      f.querySelector("[data-bs-ad-land]").textContent = text(ad.land);
      laden.hidden = true;
      felder.hidden = false;
      f.elements.strasse.focus({ preventScroll: true });
      f.scrollIntoView({ block: "nearest" });
    }).catch(function () { schliessen(); });
    f.addEventListener("submit", function (ev) {
      ev.preventDefault();
      if (laeuft) return;
      var w = {};
      AD_FELDER.forEach(function (k) { w[k] = text(f.elements[k].value).trim(); });
      var fe = {};
      Object.keys(AD_PFLICHT).forEach(function (k) { if (!w[k]) fe[k] = AD_PFLICHT[k]; });
      feldfehler(fe);
      zeigeFehler("");
      if (Object.keys(fe).length) { f.elements[Object.keys(fe)[0]].focus(); return; }
      var t = lesen();
      if (!t) { zeigeFehler(MELDUNGEN.abgelaufen); return; }
      var gleich = stand && AD_FELDER.every(function (k) { return stand.werte[k] === w[k]; });
      stand = { werte: w, schluessel: gleich ? stand.schluessel : zufall() };
      laeuft = true;
      speichernKnopf.disabled = true;
      adresseSenden("speichern", { token: t, adresse: w, schluessel: stand.schluessel }).then(function (a) {
        if (a && a.ok) {
          box.className = "mhsys-bs__hinweis mhsys-bs__hinweis--erfolg";
          box.textContent = "";
          box.appendChild(el("strong", "mhsys-bs__hinweis-titel", "Danke, deine Lieferadresse ist gespeichert."));
          box.appendChild(el("span", "", text(a.meldung) || "Deine Bestellung ist jetzt zum Versand freigegeben."));
          box.setAttribute("role", "status");
          return;
        }
        if (a && a.fehler === "felder") {
          feldfehler(a.felder || {});
          zeigeFehler(text(a.meldung));
          var erstes = AD_FELDER.filter(function (k) { return a.felder && a.felder[k]; })[0];
          if (erstes) f.elements[erstes].focus();
          return;
        }
        if (a && a.fehler === "token") merken("");
        zeigeFehler(text(a && a.meldung) || "Das hat leider nicht geklappt. Probier es gleich noch einmal.");
      }).catch(function () {
        zeigeFehler("Das hat leider nicht geklappt. Probier es gleich noch einmal.");
      }).then(function () { laeuft = false; speichernKnopf.disabled = false; });
    });
    return true;
  }
  function zufall() {
    var b = new Uint8Array(16);
    window.crypto.getRandomValues(b);
    return Array.prototype.map.call(b, function (x) { return ("0" + x.toString(16)).slice(-2); }).join("");
  }
  // Aus "Meine Bestellungen" mit "Adresse korrigieren" gekommen (sessionStorage mhsysBsAdresse = nummer): Formular gleich auf
  function adresseGewuenscht(nummer) {
    var w = "";
    try { w = sessionStorage.getItem("mhsysBsAdresse") || ""; sessionStorage.removeItem("mhsysBsAdresse"); } catch (e) { return; }
    if (!w || w !== nummer) return;
    var k = inhalt.querySelector("[data-bs-ad-auf]");
    if (k) k.click();
  }

  /* Wunschtext (status&teil=kontakt, Anlass wunschtext) - ein Feld und ein Knopf, Satz der Antwort statt Formular */
  function wunschtextFormular() {
    var f = el("form", "mhsys-formular mhsys-bs__wunsch");
    f.noValidate = true;
    var feld = el("div", "mhsys-formular__feld");
    var lab = el("label", "", "Welcher Text soll drauf?");
    lab.htmlFor = "mhsys-bs-wunschtext";
    var ta = el("textarea");
    ta.id = "mhsys-bs-wunschtext";
    ta.rows = 4;
    ta.maxLength = 2000;
    ta.placeholder = "Genau so, wie er drauf soll – bei mehreren Artikeln bitte dazuschreiben, welcher";
    feld.appendChild(lab);
    feld.appendChild(ta);
    feld.appendChild(el("span", "mhsys-formular__hinweis", "Wir antworten dir per E-Mail an die Adresse, mit der du bestellt hast."));
    f.appendChild(feld);
    var m = el("p", "mhsys-formular__meldung mhsys-formular__meldung--fehler");
    m.setAttribute("role", "alert");
    m.hidden = true;
    f.appendChild(m);
    var kn = el("div", "mhsys-bs__knoepfe");
    var knopf = el("button", "mhsys-knopf", "Wunschtext senden");
    knopf.type = "submit";
    kn.appendChild(knopf);
    f.appendChild(kn);
    f.addEventListener("submit", function (ev) {
      ev.preventDefault();
      var t = text(ta.value).trim();
      if (!t) { m.textContent = "Schreib uns bitte deinen Wunschtext."; m.hidden = false; ta.focus(); return; }
      knopf.disabled = true;
      m.hidden = true;
      stempeln({ token: lesen(), anlass: "wunschtext", nachricht: t, website: "" }).then(function (r) { return senden("kontakt", r); }).then(function (a) {
        knopf.disabled = false;
        if (a && a.ok) {
          var ok = el("p", "mhsys-bs__wunsch-ok", text(a.meldung) || "Danke, deine Nachricht ist bei uns. Wir antworten dir per E-Mail.");
          ok.setAttribute("role", "status");
          f.replaceWith(ok);
          return;
        }
        m.textContent = text(a && a.meldung) || "Das hat leider nicht geklappt. Bitte versuch es noch einmal.";
        m.hidden = false;
      }).catch(function () {
        knopf.disabled = false;
        m.textContent = "Das hat leider nicht geklappt. Bitte versuch es noch einmal.";
        m.hidden = false;
      });
    });
    return f;
  }

  function paketeZeichnen(pakete) {
    var karte = el("section", "mhsys-bs__karte");
    karte.appendChild(el("h2", "mhsys-bs__karte-titel", pakete.length > 1 ? "Deine Pakete" : "Dein Paket"));
    pakete.forEach(function (p, i) {
      var box = el("div", "mhsys-bs__paket");
      if (pakete.length > 1) box.appendChild(el("h3", "mhsys-bs__paket-titel", "Paket " + (i + 1) + " von " + pakete.length));
      box.appendChild(el("p", "mhsys-bs__paket-stand" + (p.zugestellt ? " mhsys-bs__paket-stand--zugestellt" : ""), text(p.stand)));
      if (p.meta) box.appendChild(el("p", "mhsys-bs__paket-meta", text(p.meta)));
      // Bei mehreren Paketen sagt die Zeile, welches haengt - bei einem genuegt der Kasten darueber
      if (p.haengt && pakete.length > 1) box.appendChild(el("p", "mhsys-bs__paket-haengt", "Seit über einer Woche keine neue Nachricht von DHL"));
      var verlauf = Array.isArray(p.verlauf) ? p.verlauf : [];
      if (verlauf.length > 1) {
        box.appendChild(verlaufZeichnen(verlauf.slice(0, 5)));
        if (verlauf.length > 5) {
          var mehr = el("details", "mhsys-bs__paket-mehr");
          mehr.appendChild(el("summary", "", "Alle " + verlauf.length + " Stationen"));
          mehr.appendChild(verlaufZeichnen(verlauf.slice(5)));
          box.appendChild(mehr);
        }
      }
      var link = sicher(p.link);
      if (link) {
        var z = el("p", "mhsys-bs__paket-link");
        var a = el("a", "", text(p.link_text) || "Sendung bei DHL ansehen");
        a.href = link;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        z.appendChild(a);
        box.appendChild(z);
      }
      karte.appendChild(box);
    });
    return karte;
  }

  function verlaufZeichnen(liste) {
    var ol = el("ol", "mhsys-bs__verlauf");
    liste.forEach(function (e) {
      var li = el("li");
      if (e.zeit) li.appendChild(el("span", "mhsys-bs__verlauf-zeit", text(e.zeit)));
      li.appendChild(document.createTextNode(text(e.text)));
      ol.appendChild(li);
    });
    return ol;
  }

  function artikelZeichnen(a) {
    var karte = el("section", "mhsys-bs__karte");
    karte.appendChild(el("h2", "mhsys-bs__karte-titel", "Deine Artikel"));
    var g = a.gefertigt;
    if (g && g.gesamt > 0) {
      var p = el("p", "mhsys-bs__karte-text", "Für dich gefertigt: ");
      p.appendChild(el("strong", "", text(g.fertig) + " von " + text(g.gesamt) + " fertig"));
      karte.appendChild(p);
    }
    // "Nochmal bestellen" erst ab dem Versand (Konzept 5) - vorher wirkte es wie "noch einmal kaufen, weil's nicht
    // ankommt". Wiederbestellbar ist, was eine Variante mitbringt; personalisierte Artikel bekommen "Ansehen".
    var wieder = (parseInt(a.schritt, 10) || 0) >= 4 && a.fall !== "storno";
    var posten = [];
    var personalisiert = 0;
    var liste = el("ul", "mhsys-bs__artikelliste");
    a.artikel.forEach(function (x) {
      var li = el("li", "mhsys-bs__artikel");
      // Anklickbar (Inhaber 26.09.2026): Bild und Name aufs Produkt, Schnellansicht als Overlay - nur Produkte des Shops
      var eigen = produktLink(x.link);
      eigen = /^\/products\//.test(eigen) ? eigen : "";
      var bildZiel = li;
      if (eigen) {
        bildZiel = el("a", "mhsys-bs__artikel-bildlink");
        bildZiel.href = eigen;
        bildZiel.tabIndex = -1;
        bildZiel.setAttribute("aria-hidden", "true");
        bildZiel.setAttribute("data-bs-schnellansicht", "");
        li.appendChild(bildZiel);
      }
      var bild = sicher(x.bild);
      if (bild) {
        var img = el("img", "mhsys-bs__artikel-bild");
        img.src = bild;
        img.alt = "";
        img.width = 64;
        img.height = 64;
        img.loading = "lazy";
        img.decoding = "async";
        bildZiel.appendChild(img);
      } else {
        var leer = el("span", "mhsys-bs__artikel-bild");
        leer.setAttribute("aria-hidden", "true");
        bildZiel.appendChild(leer);
      }
      var t = el("span", "mhsys-bs__artikel-text");
      if (eigen) {
        var nameLink = el("a", "mhsys-bs__artikel-name mhsys-bs__artikel-name--link", text(x.name));
        nameLink.href = eigen;
        nameLink.setAttribute("data-bs-schnellansicht", "");
        t.appendChild(nameLink);
      } else {
        t.appendChild(el("span", "mhsys-bs__artikel-name", text(x.name)));
      }
      t.appendChild(el("span", "mhsys-bs__artikel-meta", text(x.menge) + " ×" + (x.meta ? " · " + text(x.meta) : "")));
      var variante = /^[1-9][0-9]{0,19}$/.test(text(x.variante)) ? text(x.variante) : "";
      var link = produktLink(x.link);
      if (wieder && variante) {
        posten.push({ id: variante, menge: Math.min(Math.max(parseInt(x.menge, 10) || 1, 1), 999), name: text(x.name) });
      } else if (wieder && link) {
        personalisiert++;
        var an = el("a", "mhsys-bs__artikel-link", "Ansehen");
        an.href = link;
        if (/^\/products\//.test(link)) an.setAttribute("data-bs-schnellansicht", "");
        t.appendChild(an);
      }
      li.appendChild(t);
      if (x.gefertigt) {
        li.appendChild(el("span", "mhsys-bs__stand mhsys-bs__stand--" + (x.fertig ? "fertig" : "arbeit"), x.fertig ? "fertig" : "wird gefertigt"));
      }
      liste.appendChild(li);
    });
    karte.appendChild(liste);
    if (a.summe) {
      var s = el("p", "mhsys-bs__summe");
      s.appendChild(el("span", "", "Summe"));
      s.appendChild(el("span", "", text(a.summe)));
      karte.appendChild(s);
    }
    if (posten.length || personalisiert) karte.appendChild(wiederZeichnen(posten, personalisiert));
    return karte;
  }

  /* ---- Schnellansicht (Inhaber 26.09.2026) ----
     Artikel oeffnen das Produkt als Overlay - dieselbe Schnellansicht wie in der Warenkorb-Schublade
     (assets/mhsys-schnellansicht.js, Adressen und Schalter in window.mhsysSchnellansicht aus layout/theme.liquid). Das
     Skript und seine Huelle laden erst beim ersten Klick. Schalter aus, Laden gescheitert oder Strg-/Mittelklick: der
     normale Link (Produktseite). */
  var saLaden = null;
  function schnellansichtAn(cfg) {
    if (cfg.an) return true;
    try { return localStorage.getItem("mhSchnellansichtTest") === "1"; } catch (e) { return false; }
  }
  function schnellansichtLaden(cfg) {
    if (saLaden) return saLaden;
    var css = !cfg.huelle || document.querySelector('link[href="' + cfg.huelle + '"]')
      ? Promise.resolve()
      : new Promise(function (fertig) {
          var l = document.createElement("link");
          l.rel = "stylesheet";
          l.href = cfg.huelle;
          l.onload = l.onerror = function () { fertig(); };
          document.head.appendChild(l);
        });
    var skript = new Promise(function (fertig, fehler) {
      var sk = document.createElement("script");
      sk.src = cfg.skript;
      sk.onload = fertig;
      sk.onerror = fehler;
      document.head.appendChild(sk);
    });
    saLaden = Promise.all([skript, css]);
    saLaden.catch(function () { saLaden = null; });
    return saLaden;
  }
  var saWartet = false;
  wurzel.addEventListener("click", function (e) {
    var link = e.target.closest ? e.target.closest("a[data-bs-schnellansicht]") : null;
    if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (typeof window.mhsysSchnellansichtOeffnen === "function") {
      if (window.mhsysSchnellansichtOeffnen(link) !== false) e.preventDefault();
      return;
    }
    var cfg = window.mhsysSchnellansicht || {};
    if (!cfg.skript || !schnellansichtAn(cfg)) return;
    e.preventDefault();
    if (saWartet) return;
    saWartet = true;
    schnellansichtLaden(cfg).then(function () {
      saWartet = false;
      var oeffnen = window.mhsysSchnellansichtOeffnen;
      if (typeof oeffnen !== "function" || oeffnen(link) === false) window.location.href = link.href;
    }).catch(function () {
      saWartet = false;
      window.location.href = link.href;
    });
  });

  // Produktseiten des eigenen Shops (relativ) oder https - nie javascript: oder fremde Schemata
  function produktLink(url) {
    url = text(url);
    return /^\/products\/[a-z0-9][a-z0-9-]*(\?[^\s]*)?$/i.test(url) ? url : sicher(url);
  }

  /* ---- Nochmal bestellen (Roadmap 3.41 D, Konzept 5) ----
     Wie "Alle in den Warenkorb" der Merkliste: /cart/add.js in den BESTEHENDEN Korb (kein Warenkorb-Permalink - der
     ersetzt den Korb und liefe am Warenkorb-Code vorbei), danach die Schublade oeffnen. _quelle: bestellstatus an
     jeder Position, damit messbar ist, ob es genutzt wird (orpo_quelle). Nimmt Shopify den Stapel nicht (ein Artikel
     ausverkauft), geht es Artikel fuer Artikel weiter und die Meldung nennt, was fehlt. */
  function wiederZeichnen(posten, personalisiert) {
    var box = el("div", "mhsys-bs__wieder");
    var meldungW = el("p", "mhsys-formular__meldung mhsys-formular__meldung--fehler mhsys-bs__wieder-meldung");
    meldungW.setAttribute("role", "status");
    meldungW.hidden = true;
    if (posten.length) {
      var knoepfe = el("div", "mhsys-bs__knoepfe");
      var knopf = el("button", "mhsys-knopf", "Nochmal bestellen");
      knopf.type = "button";
      knopf.addEventListener("click", function () { wiederBestellen(posten, knopf, meldungW); });
      knoepfe.appendChild(knopf);
      box.appendChild(knoepfe);
    }
    if (personalisiert) {
      box.appendChild(el("p", "mhsys-bs__wieder-hinweis", personalisiert > 1
        ? "Artikel mit deinem Wunschtext gestaltest du über „Ansehen“ neu."
        : "Den Artikel mit deinem Wunschtext gestaltest du über „Ansehen“ neu."));
    }
    box.appendChild(meldungW);
    return box;
  }

  function inDenKorb(liste) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-Mhsys-Warenkorb": "1" },
      body: JSON.stringify({
        items: liste.map(function (p) { return { id: Number(p.id), quantity: p.menge, properties: { _quelle: "bestellstatus" } }; }),
      }),
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || j.status) throw new Error(text(j.description || j.message) || "Fehler");
        return j;
      });
    });
  }

  function wiederBestellen(posten, knopf, meldungW) {
    knopf.disabled = true;
    meldungW.hidden = true;
    var fehlt = [];
    inDenKorb(posten)
      .catch(function () {
        // Einzeln nachlegen - der Reihe nach, damit die Mengen im Korb nicht gegeneinander laufen
        return posten.reduce(function (kette, p) {
          return kette.then(function () { return inDenKorb([p]).catch(function () { fehlt.push(p.name); }); });
        }, Promise.resolve());
      })
      .then(function () {
        knopf.disabled = false;
        if (fehlt.length === posten.length) {
          meldungW.textContent = "Die Artikel sind gerade leider nicht verfügbar.";
          meldungW.hidden = false;
          return;
        }
        if (fehlt.length) {
          meldungW.textContent = "Gerade nicht verfügbar: " + fehlt.join(", ") + ". Alles andere liegt im Warenkorb.";
          meldungW.hidden = false;
        }
        if (window.mhsysWarenkorb && document.querySelector("mhsys-warenkorb")) window.mhsysWarenkorb.aktualisieren(true);
        else window.location.href = "/cart";
      });
  }

  /* ---- Push-Hinweis (Roadmap 3.41 D, Konzept 4) ----
     Kein Kasten, solange dieser Browser ein Abo hat; mhPushAus wird respektiert (dann nur der leise Link). Vor dem
     Versand (Schritt 1-3) wird ein Abo an diese Bestellung gebunden (teil=push) - danach nicht mehr, die Versandinfo
     ist dann vorbei; deshalb ab Schritt 4 der zweite Text. Abonniert wird ueber assets/mhsys-benachrichtigung.js
     (window.mhsysPush) mit Quelle "bestellstatus" und der Fassung aus der Vorlage in der Section.
     Ein schon vorhandenes Abo wird beim Laden gebunden - das Backend nur, wenn es das Thema "versand" hat, und nie
     ueber ein anderes (Entscheidung MASTER, 23.09.2026). Das Theme kennt die Themen nicht, es zeigt nur die Antwort. */
  function pushWeg() {
    var p = window.mhsysPush;
    return p && typeof p === "object" && p.abonnieren ? p : null;
  }

  function vorlage(platz, name) {
    var v = wurzel.querySelector('template[data-bs-push-vorlage="' + name + '"]');
    platz.textContent = "";
    if (v) platz.appendChild(v.content.cloneNode(true));
    return v;
  }

  function binden(kennung) {
    return senden("push", { token: lesen(), kennung: text(kennung) });
  }

  function pushZeichnen(platz, a) {
    var schritt = parseInt(a.schritt, 10) || 0;
    if (a.fall === "storno" || schritt < 1) return;
    var weg = pushWeg();
    if (!weg) {
      // Das Push-Skript kommt noch (oder gar nicht, wenn Push im Shop aus ist - dann bleibt der Platz leer)
      document.addEventListener("mhsys:push-bereit", function () { if (platz.isConnected) pushZeichnen(platz, a); }, { once: true });
      return;
    }
    var vorVersand = schritt <= 3;
    var blockiert = !!(window.Notification && Notification.permission === "denied");
    if (weg.iphone || !weg.kann || blockiert || weg.ausgeschaltet()) { vorlage(platz, "leise"); return; }

    var abo = weg.abo();
    if (abo && abo.kennung) {
      if (!vorVersand) { platz.textContent = ""; return; }
      binden(abo.kennung).then(function (j) {
        if (j && j.ok) vorlage(platz, j.gebunden === "anderes" ? "anderes" : "gebunden");
      }).catch(function () {});
      return;
    }

    var v = vorlage(platz, vorVersand ? "unterwegs" : "zugestellt");
    var fassung = v ? v.getAttribute("data-fassung") : "";
    var knopf = platz.querySelector("[data-bs-push-ein]");
    if (!knopf) return;
    knopf.addEventListener("click", function () {
      knopf.disabled = true;
      // Die Browser-Nachfrage im selben Klick (Nutzeraktion), nie beim Laden der Seite
      weg.erlaubnis().then(function (p) {
        if (p === "denied") { vorlage(platz, "abgelehnt"); return; }
        if (p !== "granted") { knopf.disabled = false; return; }
        return weg.abonnieren("bestellstatus", fassung).then(function (j) {
          var fertig = function () { vorlage(platz, "eingeschaltet"); };
          if (vorVersand && j && j.kennung) return binden(j.kennung).then(fertig, fertig);
          fertig();
        });
      }).catch(function () { vorlage(platz, "fehler"); });
    });
  }

  /* ---- Start ---- */
  /* ---- Bestellung aus Shopify (Inhaber 26.09.2026) ----
     Aus /pages/bestellungen (sections/mhsys-bestellungen.liquid) kommt "nummer|stelle|zeitstempel" in sessionStorage
     mhsysBsOeffnen - nicht in der Adresse. Nur eine Minute gueltig und nur einmal: gelesen = geloescht. Die Wahl bleibt
     danach in mhsysBsAuswahl stehen, damit Neuladen dieselbe Bestellung zeigt ("Zurueck zu meinen Bestellungen" loescht sie).
     Die Daten holt shopifyLaden() ueber die Section Rendering API (sections/mhsys-bestellung.liquid, paginate by 1 an der
     Stelle) und nimmt sie nur, wenn die Nummer passt. mhsys ergaenzt danach Stand, Herstellung, Push und Sendungen -
     kennt es die Bestellung nicht (unbezahlt), bleibt es bei den Shopify-Daten. */
  var bestellungenSeite = wurzel.getAttribute("data-bs-bestellungen-seite") || "";
  var AUSWAHL = "mhsysBsAuswahl";
  function auswahlPruefen(nummer, stelle) {
    nummer = text(nummer);
    stelle = parseInt(stelle, 10) || 0;
    if (!/^[A-Za-z0-9-]{1,20}$/.test(nummer)) return null;
    return { nummer: nummer, stelle: stelle > 0 && stelle < 100000 ? stelle : 0 };
  }
  function gewuenscht() {
    var w = "";
    try { w = sessionStorage.getItem("mhsysBsOeffnen") || ""; sessionStorage.removeItem("mhsysBsOeffnen"); } catch (e) { return null; }
    var teile = w.split("|");
    var zeit = parseInt(teile[teile.length - 1], 10) || 0;
    if (!(Date.now() - zeit < 60000)) return null;
    return auswahlPruefen(teile[0], teile.length > 2 ? teile[1] : 0);
  }
  function auswahlMerken(w) {
    try { w ? sessionStorage.setItem(AUSWAHL, w.nummer + "|" + w.stelle) : sessionStorage.removeItem(AUSWAHL); } catch (e) {}
  }
  function auswahlLesen() {
    var w = "";
    try { w = sessionStorage.getItem(AUSWAHL) || ""; } catch (e) { return null; }
    var teile = w.split("|");
    var a = auswahlPruefen(teile[0], teile[1]);
    return a && a.stelle ? a : null;
  }
  function nurZiffern(nummer) { return /^\d{1,12}$/.test(nummer); }

  // Kam seit der Liste eine neue Bestellung dazu, steht die gewaehlte eine Stelle weiter hinten - bis zu 5 Stellen suchen
  var SUCHWEITE = 5;
  function shopifyLaden(w, versuch) {
    versuch = versuch || 0;
    if (!versuch) zustand("laden");
    var url = window.location.pathname + "?section_id=mhsys-bestellung&page=" + (w.stelle + versuch);
    return fetch(url, { credentials: "same-origin", cache: "no-store" })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var b = doc.querySelector("[data-bs-shopify]");
        if (b && b.getAttribute("data-nummer") === w.nummer) {
          var gefunden = { nummer: w.nummer, stelle: w.stelle + versuch };
          auswahlMerken(gefunden);
          shopifyZeichnen(document.adoptNode(b), w.nummer);
          if (nurZiffern(w.nummer)) mhsysErgaenzen(w.nummer);
          return;
        }
        // Keine Bestellung mehr an der Stelle (abgemeldet, Ende der Liste): nicht weitersuchen
        if (b && versuch < SUCHWEITE) { shopifyLaden(w, versuch + 1); return; }
        auswahlMerken(null);
        ohneShopify();
      })
      .catch(function () { auswahlMerken(null); ohneShopify(); });
  }
  // Shopify liefert die Bestellung nicht: angemeldet zurueck zur Uebersicht (dort ist sie frisch), sonst die Liste aus mhsys
  function ohneShopify() {
    if (bestellungenSeite) { window.location.replace(bestellungenSeite); return; }
    meineLaden("");
  }
  function shopifyZeichnen(b, nummer) {
    inhalt.textContent = "";
    titel.textContent = "Bestellung " + nummer;
    var datum = text(b.getAttribute("data-datum"));
    unter.textContent = datum ? "vom " + datum : "";
    unter.hidden = !datum;
    var lage = el("div", "mhsys-bs__lage");
    lage.setAttribute("data-bs-lage", "");
    inhalt.appendChild(lage);
    inhalt.appendChild(b);
    gutscheinVerdrahten(b, nummer);
    hilfeSetzen(nummer, "", b.hasAttribute("data-versendet") && !b.hasAttribute("data-storniert"), true);
    zustand("ansicht");
  }
  // Gutschein-Mail noch einmal (Inhaber 07.10.2026): mhsys laesst Shopify sie an den angemeldeten Kaeufer schicken
  function gutscheinVerdrahten(b, nummer) {
    var knopf = b.querySelector("[data-bs-gutschein-senden]");
    var ausgabe = b.querySelector("[data-bs-gutschein-meldung]");
    if (!knopf || !ausgabe || !nurZiffern(nummer)) return;
    knopf.addEventListener("click", function () {
      knopf.disabled = true;
      senden("gutschein", { bestellnr: nummer })
        .then(function (a) {
          ausgabe.textContent = text(a.meldung) || MELDUNGEN[a.fehler] || "Das hat leider nicht geklappt. Bitte schreib uns.";
          ausgabe.hidden = false;
          if (!a.ok && a.fehler !== "zu_oft") knopf.disabled = false;
        })
        .catch(function () {
          ausgabe.textContent = "Das hat leider nicht geklappt. Bitte probier es gleich noch einmal.";
          ausgabe.hidden = false;
          knopf.disabled = false;
        });
    });
  }
  function mhsysErgaenzen(nummer) {
    senden("oeffnen", { bestellnr: nummer })
      .then(function (a) {
        if (!(a && a.ok && a.token)) return null;
        merken(a.token);
        return senden("ansicht", { token: a.token });
      })
      .then(function (a) {
        var platz = inhalt.querySelector("[data-bs-lage]");
        if (!a || !a.ok || !platz || text(a.nummer) !== nummer) return;
        lageZeichnen(a, platz);
        var aktiv = parseInt(a.schritt, 10) || 0;
        if (aktiv >= 4 && a.fall !== "storno") retoure.hidden = false;
        if (Array.isArray(a.adresse) && a.adresse.length) hilfeLage.name = text(a.adresse[0]);
        adresseGewuenscht(nummer);
      })
      .catch(function () {});
  }

  function start() {
    var code = window.mhsysBsCode;
    window.mhsysBsCode = "";
    if (code) { einloesen(code); return; }
    var w = gewuenscht();
    if (w && kunde && w.stelle) { shopifyLaden(w); return; }
    if (w && kunde && nurZiffern(w.nummer)) { oeffnen(w.nummer); return; }
    if (w && nurZiffern(w.nummer)) formular.elements.bestellnr.value = w.nummer;
    if (kunde) {
      var gemerkt = auswahlLesen();
      if (gemerkt) { shopifyLaden(gemerkt); return; }
      // Angemeldet ohne Wahl: die Liste ist "Meine Bestellungen" (Shopify) - ohne die Seite wie bisher die aus mhsys
      if (bestellungenSeite) { window.location.replace(bestellungenSeite); return; }
    }
    var token = lesen();
    if (token) { laden(token); return; }
    if (kunde) { meineLaden(""); return; }
    zustand("anmelden");
  }

  start();
})();
